// import './App.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ParallaxProvider } from 'react-scroll-parallax';

// Importing components
import Navbar from './components/Navbar/Navbar';
import Home from '../src/pages/Home';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';

// Importing pages
import About from './pages/About'; 
    // About Subpages
    import Mission from './pages/SubPages/Mission';
    import Tuition from './pages/SubPages/Tuition';
    import Curriculum from './pages/SubPages/Curriculum';


import Staff from './pages/Staff';
import Classes from './pages/Classes';
import ParentInvolvement from './pages/ParentInvolvement';
import CurrentFamilies from './pages/CurrentFamilies'; 
import Contact from './pages/Contact';
import Application from './pages/Application';
import Fundraising from './pages/Fundraising'; 




function App() {

  return (
    <>

      <ParallaxProvider>
      <Router>
        <ScrollToTop />
        <Navbar/>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About/>} />
            <Route path="/about/mission" element={<Mission />} />
            <Route path="/about/curriculum" element={<Curriculum />} />
            <Route path="/about/tuition" element={<Tuition />} />

            <Route path="/staff" element={<Staff />} />
            <Route path="/parent-involvement" element={<ParentInvolvement />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/fundraising" element={<Fundraising />} />
            <Route path="/current-families" element={<CurrentFamilies />}/>
            <Route path="/contact" element={<Contact />} />            
            <Route path="/application" element={<Application />} />
          </Routes>
        {/* Add footer or other components here if needed */}
        <Footer />
      </Router>
      </ParallaxProvider>
    </>
  );
}

export default App;
